export default Usuario;

import * as _ from 'lodash';

/** @ngInject */
function Usuario(Api, $localStorage, $state, $http, $timeout, $window, $mdDialog: angular.material.IDialogService) {
  let body = angular.element($window.document.body);
  let alert = $mdDialog.alert().parent(body).ok('Fechar');

  this.obterUsuario = obterUsuario;
  this.estaLogado = estaLogado;
  this.tokenStatus = tokenStatus;
  this.login = login;
  this.esqueciMinhaSenha = esqueciMinhaSenha;
  this.logout = logout;
  this.cadastrar = cadastrar;
  this.atualizar = atualizar;
  this.alterarSenha = alterarSenha;
  this.tiposVeiculos = obterTiposVeiculos();
  this.tiposCarroceria = obterTiposCarroceria();
  this.tiposOrdenacao = obterTiposOrdenacao();
  this.find = find;
  this.dialog = dialog;

  function obterUsuario() {
    return $localStorage.usuario || {};
  }

  function estaLogado() {
    return $localStorage.usuario && $localStorage.usuario.ds_token;
  }

  function tokenStatus() {
    if (estaLogado()) {
      setarTokenHttp();

      Api
        .buscarDados('Usuario', 'tokenStatus')
        .then(salvarToken)
        .catch(function (res) {
          if (res.status === 401) {
            logout();
          }
        });
    }
  }

  function login(credenciais) {
    return Api
      .enviarDados('Usuario', 'login', {credenciais: credenciais})
      .then(salvarToken);
  }

  function esqueciMinhaSenha(credenciais) {
    return Api.enviarDados('Usuario', 'esqueciMinhaSenha', {credenciais: credenciais});
  }

  function logout() {
    $timeout(function () {
      delete $http.defaults.headers.common.Authorization;
      delete $localStorage.usuario;
      $state.go('consulta.usuario.login');
    }, 0);
  }

  function cadastrar(dados) {
    return Api
      .enviarDados('Usuario', 'cadastrar', {dados: dados})
      .then(salvarToken);
  }

  function atualizar(dados) {
    return Api
      .enviarDados('Usuario', 'atualizar', {dados: dados})
      .then(salvarToken);
  }

  function alterarSenha(dados) {
    return Api
      .enviarDados('Usuario', 'alterarSenha', {dados: dados});
  }

  function salvarToken(data) {
    $localStorage.usuario = _.assign(data, {coords: ($localStorage.usuario || {}).coords});

    setarTokenHttp();

    return data;
  }

  function setarTokenHttp() {
    $http.defaults.headers.common.Authorization = 'Bearer ' + $localStorage.usuario.ds_token;
  }

  function obterTiposVeiculos() {
    return [
      {id: 0, label: 'Todos'},
      {id: 3, label: 'VLC (< 3.9t)'},
      {id: 2, label: '3/4 (< 4t)'},
      {id: 1, label: 'Toco (< 8t)'},
      {id: 5, label: 'Truck (< 15t)'},
      {id: 4, label: 'Bitruck (< 22t)'},
      {id: 9, label: 'Carreta (< 25t)'},
      {id: 8, label: 'Carreta LS (< 27t)'},
      {id: 7, label: 'Bitrem (< 35t)'},
      {id: 6, label: 'Rodotrem (< 40t)'},
    ];
  }

  function obterTiposCarroceria() {
    return [
      {id: 0, label: 'Todos'},
      {id: 1, label: 'Baú'},
      {id: 2, label: 'Baú Frigorífico'},
      {id: 12, label: 'Boiadeiro'},
      {id: 8, label: 'Bug Porta Container'},
      {id: 4, label: 'Caçamba'},
      {id: 13, label: 'Gaiola'},
      {id: 5, label: 'Grade Baixa'},
      {id: 6, label: 'Graneleiro'},
      {id: 9, label: 'Munck'},
      {id: 14, label: 'Passageiros'},
      {id: 7, label: 'Prancha'},
      {id: 3, label: 'Sider'},
      {id: 10, label: 'Silo'},
      {id: 11, label: 'Tanque'},
    ];
  }

  function obterTiposOrdenacao() {
    return [
      {id: 0, label: 'Mais recente'},
      {id: 1, label: 'Melhor preço'},
      {id: 2, label: 'Maior distância'},
    ];
  }

  function find(lista, id) {
    return _.find(lista, (obj: any) => parseFloat(obj.id) === parseFloat(id));
  }

  function dialog(titulo: string, conteudo = '') {
    $mdDialog.hide();
    alert.title(titulo);
    alert.textContent(conteudo);
    $mdDialog.show(alert);
  }
}



/** WEBPACK FOOTER **
 ** ./common/services/usuario.service.ts
 **/